export default __webpack_public_path__ + "static/image_les_suites-26368a9d40723284fb78a3bbdb713275.jpg";